import {CookieConsent} from '@inventis/cookieconsent';
import {DialogBlockDetector} from '@inventis/cookieconsent/src/plugins/DialogBlockDetector';
import {PermissionDependantTemplateHandler} from '@inventis/cookieconsent/src/plugins/PermissionDependantTemplateHandler';
import {CookieDialogTrigger} from '@inventis/cookieconsent/src/plugins/CookieDialogTrigger';
import {GoogleTagManager} from '@inventis/cookieconsent-googletagmanager-plugin';

export default (dialog) => {
    return new CookieConsent(dialog, {
        plugins: [
            new DialogBlockDetector(),
            new PermissionDependantTemplateHandler(),
            new CookieDialogTrigger(),
            new GoogleTagManager(),
        ],
    });
};
